module.exports = __webpack_public_path__ + "static/media/anytimewages.b5cfcba2.png";